import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "axios";

import WrongInputMessage from "./WrongInputMessage";
import ErrorMessage from "./ErrorMessage";

const LoginForm = ({ onLoggedIn, returnAPIBaseUrl }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (state === null) {
      navigate(1);
    }
  });

  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");
  const [inputError, setInputError] = useState(false);
  const [serverError, setServerError] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    // Special conditions for support login
    let orderNumberPlain;
    let support = false;

    if (orderNumber.includes("@support")) {
      orderNumberPlain = orderNumber.replace("@support", "");
      support = true;
    } else {
      orderNumberPlain = orderNumber;
    }

    const params = { orderNumberPlain, email, support };

    // Send request to server to check user data
    axios
      .get(`${returnAPIBaseUrl}/login`, { params: params })
      .then((response) => {
        const data = response.data;

        if (data.orderNumber === orderNumberPlain && data.email === email) {
          sessionStorage.setItem("user", JSON.stringify({ orderNumber: orderNumberPlain, email: email, supportLogin: support }));

          onLoggedIn();
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 503) {
            setServerError(error.message);
          } else {
            setInputError(true);
          }
          // Request made and server responded
        } else if (error.request) {
          // Request made but no response received
          setServerError(error.message);
        } else {
          // Sth else happened
          setError(error.message);
        }
      });
  };

  return (
    <div className="form-container">
      <h1 className="h1">{t("loginView.logIn")}</h1>
      {inputError && <WrongInputMessage inputError={inputError} />}
      {inputError && (
        <p className="general-return-link">
          {t("loginView.generalReturnPrompt")}{" "}
          <Link to="/general-return">{t("loginView.generalReturnLink")}</Link>
        </p>
      )}
      {serverError && <ErrorMessage errorMessage={serverError} />}
      {error && <ErrorMessage errorMessage={error} />}
      <Form className="login-form" onSubmit={handleLogin}>
        <Form.Group className="mb-3" controlId="formBasicOrderNumber">
          <Form.Control className="" type="text" placeholder={t("loginView.orderNumberPlaceholder")} onFocus={(e) => (e.target.placeholder = "")} onBlur={(e) => (e.target.placeholder = t("loginView.orderNumberPlaceholder"))} name="ordernumber" onChange={(e) => setOrderNumber(e.target.value)} required />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Control className="" type="email" placeholder={t("loginView.emailPlaceholder")} onFocus={(e) => (e.target.placeholder = "")} onBlur={(e) => (e.target.placeholder = t("loginView.emailPlaceholder"))} name="email" onChange={(e) => setEmail(e.target.value.toLowerCase())} required />
        </Form.Group>
        <Button className="btn" variant="dark" type="submit">
          {t("buttons.continue")}
        </Button>
      </Form>
    </div>
  );
};

export default LoginForm;
